import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DatabaseDateFormatService {
	private readonly pickerFormatter = new Intl.DateTimeFormat('de-DE', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
	});
	private readonly periodFormatter = new Intl.DateTimeFormat('de-DE');

	public formatPickerDate(value: Date): string {
		return this.pickerFormatter.format(value);
	}

	public formatPickerRange(start: Date | null, end: Date | null): string {
		return this.formatRange(start, end, this.pickerFormatter);
	}

	public formatPeriodRange(start: Date | null, end: Date | null): string {
		return this.formatRange(start, end, this.periodFormatter);
	}

	public formatResponseDate(value?: string | null): string {
		if (!value) return '';
		// Preserve the backend calendar day without converting timestamp offsets.
		const [year, month, day] = value.slice(0, 10).split('-');
		if (!year || !month || !day) return '';
		return `${day}.${month}.${year}`;
	}

	private formatRange(start: Date | null, end: Date | null, formatter: Intl.DateTimeFormat): string {
		if (start && end) return `${formatter.format(start)} - ${formatter.format(end)}`;
		if (start) return `${formatter.format(start)} -`;
		if (end) return `- ${formatter.format(end)}`;
		return '';
	}
}
